/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 10:54
 */
import Column from './Column';
import 'select2';

class MultiDropdownColumn extends Column {

  constructor(params) {
    super(params);
    this.init();
  }

  init() {
    const select = this.root.querySelector('.js-column-value');
    const placeholder = "Choose an option";

    $(select).select2({
      allowClear: true,
      containerCssClass: select.getAttribute('class'),
      dropdownAutoWidth: true,
      dropdownCssClass: 'dropdown-menu dropdown-menu-right dropdown-menu-sm show',
      placeholder: placeholder,
      width: '100%',
    });
  }

}

export default MultiDropdownColumn;



// WEBPACK FOOTER //
// ./resources/assets/js/columns/MultiDropdownColumn.js